export enum AssetStatus {
  available = 'available',
  assigned = 'assigned',
  to_repair = 'to_repair',
  in_service = 'in_service',
  discarded = 'discarded',
  disabled = 'disabled',
}

export const AssetStatusLabels: Record<AssetStatus, string> = {
  [AssetStatus.available]: 'Disponible',
  [AssetStatus.assigned]: 'Asignado',
  [AssetStatus.to_repair]: 'Por Reparar',
  [AssetStatus.in_service]: 'En Reparación',
  [AssetStatus.discarded]: 'Dado de Baja',
  [AssetStatus.disabled]: 'Deshabilitado',
};
